import { createApp } from 'vue'
import App from './App.vue'
import './styles.css'; // Import the global CSS file


createApp(App).mount('#app')
